/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TimeOfDayRequest
 */
export interface TimeOfDayRequest {
    /**
     * 
     * @type {number}
     * @memberof TimeOfDayRequest
     */
    fromHours?: number;
    /**
     * 
     * @type {number}
     * @memberof TimeOfDayRequest
     */
    fromMinutes?: number;
    /**
     * 
     * @type {number}
     * @memberof TimeOfDayRequest
     */
    toHours?: number;
    /**
     * 
     * @type {number}
     * @memberof TimeOfDayRequest
     */
    toMinutes?: number;
}

export function TimeOfDayRequestFromJSON(json: any): TimeOfDayRequest {
    return TimeOfDayRequestFromJSONTyped(json, false);
}

export function TimeOfDayRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): TimeOfDayRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fromHours': !exists(json, 'fromHours') ? undefined : json['fromHours'],
        'fromMinutes': !exists(json, 'fromMinutes') ? undefined : json['fromMinutes'],
        'toHours': !exists(json, 'toHours') ? undefined : json['toHours'],
        'toMinutes': !exists(json, 'toMinutes') ? undefined : json['toMinutes'],
    };
}

export function TimeOfDayRequestToJSON(value?: TimeOfDayRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'fromHours': value.fromHours,
        'fromMinutes': value.fromMinutes,
        'toHours': value.toHours,
        'toMinutes': value.toMinutes,
    };
}


